/**
 * Sidemenu actions
 */
import { dispatch } from 'store';

import { SIDEMENU_OPEN } from '../action-types/sidemenu.action-types';

// eslint-disable-next-line import/prefer-default-export
export const openSideMenu = (isOpen: boolean) => dispatch({ type: SIDEMENU_OPEN, isOpen });
